import { render, staticRenderFns } from "./copied.vue?vue&type=template&id=6996e872&scoped=true&"
import script from "./copied.vue?vue&type=script&lang=js&"
export * from "./copied.vue?vue&type=script&lang=js&"
import style0 from "./copied.vue?vue&type=style&index=0&id=6996e872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996e872",
  null
  
)

export default component.exports